// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

export const StyledAuthPanelInput = styled.input`
	display: block;
	width: 100%;
	background-color: var(--dz-sys-input-background-color-darken);
	border-radius: var(--dz-ref-border-radius-1-50);
	padding: 0.5rem 1rem;
	font-size: 1.1rem;
	font-weight: bold;
	color: var(--dz-sys-input-text-color);

	&::-ms-reveal,
	&::-ms-clear {
		display: none;
	}

	&:focus {
		background-color: var(--dz-ref-color-white);
	}

	${({ active }) =>
		active &&
		css`
			background-color: var(--dz-ref-color-white);
		`}

	${({ register }) =>
		register &&
		css`
			height: 42px;
			padding: 0 1rem;
		`}

	${({ withBoxShadow }) =>
		withBoxShadow &&
		css`
			box-shadow: var(--dz-comp-auth-panel-box-shadow);
		`}
`;

// #####################################################
